import { render } from "./Show.vue?vue&type=template&id=82e3a5f6"
import script from "./Show.vue?vue&type=script&lang=js"
export * from "./Show.vue?vue&type=script&lang=js"

import "./Show.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script